import React, {Component} from 'react';
import { compose, withHandlers } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import { commonStyles } from '../../styles/styles';
import PropTypes from 'prop-types';

import Select from 'react-select';

import {MDBSelect} from 'mdbreact'

class renderText extends Component {

  state = {
  };

  componentWillReceiveProps(nextProps){
    
    if(this.props.options!=nextProps.options){
      console.log('GO NO GO FIX',  this.props.options, nextProps.options)
      var opt =[]
     
        try {
          nextProps.options.forEach((item) => {
            opt.push({'text': item.email, 'value': item.email});
          })
        } catch (error) {
          
        }
      this.setState({
        options: opt
       })
    }
  
    }
  onChange = (event) => {
    
   if (this.props.input.onChange && event.length != 0) {
    console.log('GO NO GO CHANGE', event[0])
    this.props.input.onChange(event[0]);
   } else {
    
    this.props.input.onChange(null);
   }
  }
 
  render() {
   
   const { classes, meta, registrationForm, input, label, options, linkedData } = this.props;
   const conditionError = meta.error && meta.touched;
  //  if ((input.name === 'conClientBranchID' || input.name === 'conClientRegionID')
  //     && form.registration.values.conClientID) {
  //   this.props.options.forEach((item) => {
  //     if (item.conClientID === form.registration.values.conClientID) {
  //       linkedData.push({'Name': item.Name, 'iID': item.iID});
  //     }
  //   });
  // }
 // const dataToShow2 = linkedData.length > 0 ? linkedData : data;
  
  
   return (
    <FormControl
      
      aria-describedby="name-error-text"
      error={conditionError}
      style={{width:"100%", borderRadius:'0px',fontFamily: 'Roboto', fontSize:'14px', color: '#000', minHeight:'42px', paddingTop:25}}
    >
      {console.log('GO NO GO INPUT', this.props.input)}
      <MDBSelect
        search
        {...input}
          name={label}
          label={label}
          value={this.props.input.value || ''}
          options={this.state.options}
          selected={'Choose your option'}
          getValue={this.onChange}
          style = {{height:200}}
        />
      {/* <Select 
    {...input}
    name={label}
    options={opt}
    value={this.props.input.value || ''}
    onBlur={() => this.props.input.onBlur(this.props.input.value)}
    onChange={this.onChange.bind(this)}
    theme={theme => ({
      ...theme,
      borderRadius: 0,
      borderColor: '#9E9E9E',
      color: '#000',
      fontSize: '14px',
      fontFamily: 'Roboto-Bold',
      minHeight:'42px'
    })}
   /> */}
      {conditionError && (
        <FormHelperText id="name-error-text" className={classes.errorBottomText}>
          Please select a user
        </FormHelperText>
      )}
    </FormControl>
   );
  }
 }
 export default compose(withStyles(styles))(renderText)

const styles = () => ({
  ...commonStyles,
});





// WEBPACK FOOTER //
// ./src/Components/Form/Dropdown.jsx